var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"all_dy"},[_vm._v(" 全部订阅 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }